import styled from "styled-components";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

export const StyledOuterContainer = styled.div`
  width: 644px;
  height: 184px;

  display: flex;

  margin: auto;
  justify-content: space-around;

  @media ${MEDIA_QUERIES.MOBILE} {
    justify-content: flex-start;
    width: 450px;
  }
`;

export const StyledInnerContainer = styled.div<{ margin?: string }>`
  width: 200px;

  padding: 0 20px;

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  margin: ${({ margin = "0" }) => margin};

  background-color: ${({ theme }) => theme.colors.primaryAkbankWhite};

  border-radius: 8px;
`;
